export const changeSelection = (pool, records, checked) => {
  const next = new Map(pool);
  records.forEach((record) => {
    if (checked) next.set(record.tenantId, record);
    else next.delete(record.tenantId);
  });
  return next;
};

export const refreshSelection = (pool, records) => {
  const next = new Map(pool);
  records.forEach((record) => {
    if (next.has(record.tenantId)) next.set(record.tenantId, record);
  });
  return next;
};

export const selectionTotal = (records) =>
  records.reduce((sum, row) => sum + Math.round(Number(row.amount || 0) * 100), 0) / 100;

export const newDownloadId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
